import { Icon } from "./Icon.tsx";

/** "Aquifers" tab icon — ground surface, a well bore, and 2 wavy
 * groundwater layers, distinct from LidControlIcon.tsx's own straight
 * horizontal layer lines (solid filter media, not a water table). */
export function AquiferIcon() {
  return (
    <Icon>
      <path d="M3 7h18" />
      <path d="M12 2.5v5" />
      <path d="M3 13c2-1.2 4 1.2 6 0s4-1.2 6 0 4-1.2 6 0" />
      <path d="M3 18c2-1.2 4 1.2 6 0s4-1.2 6 0 4-1.2 6 0" />
    </Icon>
  );
}
